import { render, staticRenderFns } from "./GrapejsWebsiteBuilder.vue?vue&type=template&id=526fc5bf&"
import script from "./GrapejsWebsiteBuilder.vue?vue&type=script&lang=js&"
export * from "./GrapejsWebsiteBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526fc5bf')) {
      api.createRecord('526fc5bf', component.options)
    } else {
      api.reload('526fc5bf', component.options)
    }
    module.hot.accept("./GrapejsWebsiteBuilder.vue?vue&type=template&id=526fc5bf&", function () {
      api.rerender('526fc5bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/websitebuilder/GrapejsWebsiteBuilder.vue"
export default component.exports